// extracted by mini-css-extract-plugin
export default {"reportWrap":"MailReport-module--report-wrap--2EhCB"};